import React, { useState } from 'react';
import CameraCapture from './CameraCapture.jsx';
import { isProduitCher } from '../lib/produits-chers.js';

export default React.memo(function PrepPhotosSection({ photos, uploading, fileInputRef, onUpload, onRemove, onRefreshUrls, products, onControlPhoto }) {
  const [cameraOpen, setCameraOpen] = useState(false);
  const chers = (products || []).filter(p => isProduitCher(p));

  return (
    <>
      {/* ═══ Produits sensibles : photo du produit DANS LA CAISSE ═══ */}
      {chers.length > 0 && (
        <div style={{ marginBottom: 10, padding: '10px 12px', borderRadius: 10, background: '#FDFAF4', border: '1.5px solid #b5904a' }}>
          <div style={{ fontSize: 11, fontWeight: 800, color: '#8a6a30', marginBottom: 6 }}>
            PRODUITS SENSIBLES — une photo de chaque produit POSÉ DANS LA CAISSE
          </div>
          {chers.map(p => {
            const done = (photos || []).some(ph => String(ph.control_product_id) === String(p.id));
            return (
              <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 8px', borderRadius: 8, background: 'white', border: '0.5px solid ' + (done ? '#16A34A' : '#b5904a'), marginBottom: 4 }}>
                <div style={{ flex: 1, minWidth: 0, fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{p.name}</div>
                {done ? (
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#16A34A', flexShrink: 0 }}>✅ Prise</span>
                ) : (
                  <button onClick={() => {
                    const input = document.createElement('input');
                    input.type = 'file'; input.accept = 'image/*'; input.capture = 'environment';
                    input.onchange = (e) => { const f = e.target.files?.[0]; if (f && onControlPhoto) onControlPhoto(p.id, f); };
                    input.click();
                  }} disabled={uploading} style={{
                    padding: '8px 12px', borderRadius: 8, border: 'none', background: '#b5904a',
                    color: 'white', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0, fontFamily: 'inherit',
                  }}>📷 Photo caisse</button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Bouton unique — ouvre la caméra live */}
      <button onClick={() => setCameraOpen(true)} disabled={uploading} style={{
        width: '100%', padding: '16px 14px', borderRadius: 10,
        border: '1.5px dashed #1A5276', background: '#F0F7FF',
        cursor: uploading ? 'wait' : 'pointer', textAlign: 'center', fontFamily: 'inherit',
        marginBottom: 8,
      }}>
        <div style={{ fontSize: 22, marginBottom: 2 }}>{uploading ? '⏳' : '📷'}</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#1A5276' }}>
          {uploading ? 'Upload en cours…' : 'Prendre des photos'}
        </div>
      </button>

      {/* Grille photos */}
      {photos.length > 0 && (
        <div style={{ fontSize: 11, fontWeight: 600, color: '#9CA3AF', marginBottom: 4 }}>
          {photos.length} photo{photos.length > 1 ? 's' : ''}
        </div>
      )}

      {photos.length === 0 && !uploading && (
        <div style={{ textAlign: 'center', padding: 12, color: '#D1D5DB', fontSize: 12 }}>
          Aucune photo
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
        {photos.map(p => {
          const time = p.uploaded_at ? new Date(p.uploaded_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '';
          return (
            <div key={p.id} style={{ borderRadius: 8, overflow: 'hidden', border: '0.5px solid #E8E8EE', background: 'white', position: 'relative' }}>
              <img src={p.url} alt="" style={{
                width: '100%', aspectRatio: '1', objectFit: 'cover', display: 'block', cursor: 'pointer',
              }} onClick={() => window.open(p.url, '_blank')}
              onError={(e) => {
                // URL signée expirée (page ouverte longtemps) → re-signer une fois
                if (!e.target.dataset.retried) { e.target.dataset.retried = '1'; onRefreshUrls?.(); }
              }} />
              <button onClick={() => onRemove(p)} style={{
                position: 'absolute', top: 4, right: 4,
                width: 22, height: 22, borderRadius: '50%',
                background: 'rgba(0,0,0,0.5)', border: 'none', color: 'white',
                fontSize: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>✕</button>
              <div style={{ padding: '3px 6px', fontSize: 9, color: '#9CA3AF' }}>{time}</div>
            </div>
          );
        })}
      </div>

      {/* Caméra live */}
      <CameraCapture
        open={cameraOpen}
        onClose={() => setCameraOpen(false)}
        onCapture={(file) => onUpload(file)}
      />
    </>
  );
});
